import { render, staticRenderFns } from "./SecondaryNavItem.vue?vue&type=template&id=339640f0&"
import script from "./SecondaryNavItem.vue?vue&type=script&lang=js&"
export * from "./SecondaryNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryNavItem.vue?vue&type=style&index=0&id=339640f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports